import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { palette } from '../theme';
import { Spinner } from '../spinner';
import { ActionButton } from '../buttons';
import { Modal } from './modal';

interface ProgressModalProps {
  open: boolean;
  title: string;
  subtitle?: string;
  /** 0–100. */
  percent: number;
  done?: boolean;
  cancelLabel?: string;
  onCancel?: () => void;
}

export const ProgressModal: React.FC<ProgressModalProps> = ({
  open,
  title,
  subtitle,
  percent,
  done,
  cancelLabel,
  onCancel
}) => (
  <Modal open={open}>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        padding: '8px 8px 0'
      }}
    >
      {done ? <CheckCircle2 size={40} color={palette.primitives.purple.purple400} /> : <Spinner size={40} />}

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <span
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: palette.primitives.slate.slate900,
            textAlign: 'center'
          }}
        >
          {title}
        </span>
        {subtitle && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: palette.primitives.slate.slate500,
              textAlign: 'center',
              lineHeight: 1.45
            }}
          >
            {subtitle}
          </span>
        )}
      </div>

      <div style={{ width: '100%', marginTop: 4 }}>
        <div
          style={{
            height: 6,
            background: palette.primitives.grey.grey50,
            borderRadius: 99,
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              height: '100%',
              width: `${percent}%`,
              background: palette.primitives.purple.purple400,
              borderRadius: 99,
              transition: 'width 0.4s ease'
            }}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 6 }}>
          <span style={{ fontSize: 12, color: palette.primitives.slate.slate500 }}>{percent}%</span>
        </div>
      </div>

      {cancelLabel && (
        <ActionButton fullWidth onClick={onCancel} style={{ marginTop: 8 }}>
          {cancelLabel}
        </ActionButton>
      )}
    </div>
  </Modal>
);
